import { halfPageManagerState as state } from './halfPageManagerState';
import * as consts from './halfPageManagerConstants';
import * as els from './halfPageManagerElements';

// Nastavení bannerů a stavu před jejich následným přidáním do stránky
export const halfPageManagerPrepareRepeaters = (oldContentHeight: number): void => {
  // Pokud se výška nezměnila nebo z nějakého záhadného důvodu snížila, nic nepřidáváme
  if (state.getContentHeight() - oldContentHeight <= 0) {
    return;
  }

  // Spočítáme výšku volného místa, rozpočítáme mezi bannery a volné místo pro poslední banner, hodnoty uložíme
  let freeSpaceAvailable: number =
    state.getContentHeight() - oldContentHeight + state.getLastBannerHeight();

  // Nové bannery vkládáme jen pokud výška posledního repeateru přesáhne maximální / limitní výšku pro tento
  if (freeSpaceAvailable >= consts.HALFPAGE_WRAPPER_MAX_HEIGHT) {
    const newRepeaterCount: number = Math.floor(
      freeSpaceAvailable / consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT
    );
    state.setRepeaterBannerInsertCount(newRepeaterCount);

    const takenBannerSpace: number =
      state.getRepeaterBannerInsertCount() * consts.HALFPAGE_WRAPPER_DEFAULT_HEIGHT;
    freeSpaceAvailable -= takenBannerSpace;
  }

  state.setLastBannerHeight(freeSpaceAvailable);

  // Aktualizujeme výšku topBanneru s miniplayerem
  if (els.topAside && els.topBanner) {
    const miniplayerHeight = els.miniplayer?.offsetHeight || 0;

    const currentHeight = parseInt(els.topBanner.style.height, 10) || 0;
    if (currentHeight > 0) {
      els.topBanner.style.height = `${currentHeight + miniplayerHeight}px`;
    }
  }
};
